import { APIRoute } from '@/modules/utils'
import { PublicProfile } from '@/data'

export const Route: APIRoute = {
  method: 'GET',
  path: 'v2/profiles/:profileId',
}

export type UrlParams = {
  profileId: string
}

export type Response = PublicProfile
